import { useState, useEffect, useCallback } from 'react'
import { baseURL } from '../../config'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { setLoader, setRefreshPage } from '../../../redux/globalSlice'

const useGlobal = ({ userUrl }) => {
  const dispatch = useDispatch()
  const refresh = useSelector((state) => state.global.refreshPage)

  const url = userUrl ? `${baseURL}${userUrl}` : null

  const [data, setData] = useState(null)
  const [salaryData, setSalaryData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [count, setCount] = useState(0)

  const [totalFee, setTotalFee] = useState(0)
  const [totalPaidFee, setTotalPaidFee] = useState(0)
  const [totalUnpaidFee, setTotalUnpaidFee] = useState(0)
  const [pendingMonth, setPendingMonth] = useState(0)
  const [totalAbsent, setTotalAbsent] = useState(0)
  const [totalAttendance, setTotalAttendance] = useState(0)
  const [totalLeave, setTotalLeave] = useState(0)
  const [totalPresent, setTotalPresent] = useState(0)
  const [credit, setCredit] = useState(0) // fixed capitalization

  // Memoized fetch function
  const fetchData = useCallback(async () => {
    // Skip if no URL
    if (!url) {
      setLoading(false)
      setData(null)
      setCount(0)
      setTotalFee(0)
      setTotalPaidFee(0)
      setTotalUnpaidFee(0)
      setPendingMonth(0)
      setCredit(0)
      setTotalAbsent(0)
      setTotalAttendance(0)
      setTotalLeave(0)
      setTotalPresent(0)
      setSalaryData(null)

      return
    }

    try {
      dispatch(setLoader(true))
      setLoading(true)

      const response = await axios.get(url)
      const resData = response.data
      const credData = resData?.credit
      setSalaryData(resData?.salaryData)
      setData(resData?.data ?? null)
      setCount(resData?.count ?? 0)
      setTotalFee(resData?.totalFee ?? 0)
      setTotalPaidFee(resData?.totalPaidFee ?? 0)
      setTotalUnpaidFee(resData?.totalUnpaidFee ?? 0)
      setPendingMonth(resData?.pendingMonth ?? 0)
      setTotalAbsent(resData?.total_absent ?? 0)
      setTotalAttendance(resData?.total_attendance ?? 0)
      setTotalLeave(resData?.total_leave ?? 0)
      setTotalPresent(resData?.total_present ?? 0)
      setCredit(credData ?? 0)
    } catch (err) {
      setError(err)
      console.error('useGlobal fetch error:', err)
    } finally {
      setLoading(false)
      dispatch(setLoader(false))
      dispatch(setRefreshPage(false))
    }
  }, [url, dispatch]) // ← dependencies that affect the fetch function

  useEffect(() => {
    fetchData()
  }, [fetchData, refresh]) // ← now depends on stable fetchData + refresh
  const refetch = useCallback(() => {
    fetchData()
  }, [fetchData])
  return {
    data,
    loading,
    error,
    count,
    totalFee,
    totalPaidFee,
    totalUnpaidFee,
    pendingMonth,
    totalAbsent,
    totalAttendance,
    totalPresent,
    totalLeave,
    credit,
    salaryData,
    
    refetch,
  }
}

export default useGlobal
